import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/LP/FlamingoLP/Flamingo'

const Flamingo: React.FunctionComponent = () => {
  return (
    <>
      <CustomHead
        keyword={'flamingo,フラミンゴ,レスポンシブウェブ,スマホ変換,MFI,モバイルファーストインデックス'}
        image={'https://aitria.co.jp/img/LP/flamingo/ogp.png'}
        url={'https://aitria.co.jp/products/flamingo/'}
        title="ウェブシステム モダナイゼーション flamingo | サービス | Aitria（アイトリア）"
        description="既存システムの資産を有効活用し、プログラムに手を加えることなく最新のウェブシステムに変換ができるサービスです。"
        faviconPng="/img/LP/flamingo/favicon_f.png"
        faviconSvg="/img/LP/flamingo/favicon_f.svg"
      />
      <Template />
    </>
  )
}

export default Flamingo
